type ActivityMonitorOptions = {
  cooldownMs: number; // minimum time between callback function calls
  events: string[]; // events that count as activity
  onActive: () => void; // callback function to be executed after activity
  targetEl: Window | HTMLElement; // element to listen for activity on
  fireImmediately: boolean; // fire callback once when the class is created instead of waiting for events
};

const DEFAULT_OPTIONS: ActivityMonitorOptions = {
  cooldownMs: 10000,
  events: [`mousemove`, `keydown`, `mousedown`, `touchstart`],
  onActive: () => undefined,
  targetEl: window,
  fireImmediately: false,
};

export class ActivityMonitor {
  private declare settings: ActivityMonitorOptions;
  private lastBeat: number | null = null;
  private declare activityCallback: () => void;

  constructor(options: Partial<ActivityMonitorOptions>) {
    this.settings = Object.assign({}, DEFAULT_OPTIONS, options);

    this.activityCallback = () => {
      const now = Date.now();
      if (this.lastBeat === null || now - this.lastBeat > this.settings.cooldownMs) {
        this.lastBeat = now;
        this.settings.onActive();
      }
    };

    if (options.fireImmediately) {
      this.activityCallback();
    }
  }

  public start() {
    this.settings.events.forEach((event) => this.settings.targetEl.addEventListener(event, this.activityCallback));
    return this;
  }

  public stop() {
    this.settings.events.forEach((event) => this.settings.targetEl.removeEventListener(event, this.activityCallback));
    return this;
  }
}
